import { mapActions } from 'vuex';
import marketChangePrice from '@/components/market/market-change-price/market-change-price.vue';
import query from '@/helpers/query';
import log from '@/logger';

export default {
  components: {
    marketChangePrice,
  },
  props: {
    widget: Object,
  },
  computed: {
    obj() {
      return this.widget ? this.widget : {};
    },
  },
  methods: {
    ...mapActions('browse', ['addFilter', 'setTimespanFromQuery', 'setOrderFromQuery']),
    onClick() {
      if (this.obj.marketUrl) {
        const queryObj = query.unserializeQuery(this.obj.marketUrl);
        let storeModified = false;
        if (queryObj.filterIds) {
          queryObj.filterIds.split(',').forEach((i) => {
            const filterId = parseInt(i, 10);
            log.info(`[MARKETS] filterId passed: ${filterId}`);
            if (filterId) {
              storeModified = true;
              this.addFilter(filterId);
            }
          });
        }
        if (queryObj.sortParameter) {
          storeModified = true;
          this.setTimespanFromQuery({
            parameter: queryObj.sortParameter,
            dateFrom: queryObj.dateFrom,
            dateTo: queryObj.dateTo,
          });
        }
        if (queryObj.sort) {
          storeModified = true;
          this.setOrderFromQuery(queryObj.sort);
        }
        const url = storeModified ? `${this.obj.marketUrl}&widget` : this.obj.marketUrl;
        this.$router.push(url);
      }
    },
  },
};
